import CONST_COMPONENT from '../const/component'

export default {
  reference: {
    name: CONST_COMPONENT.POSTBACK,
    component: 'ReferenceComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  text: {
    name: CONST_COMPONENT.TEXT,
    component: 'TextComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  image: {
    name: CONST_COMPONENT.IMAGE,
    component: 'ImageComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  genericTemplate: {
    name: CONST_COMPONENT.GENERIC_TEMPLATE,
    component: 'GenericTemplateComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
      componentHandler: 'componentHandler.js'
    },
  },

  carousel: {
    name: CONST_COMPONENT.CAROUSEL,
    component: 'CarouselComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
      componentHandler: 'componentHandler.js',
    },
  },

  carouselSingle: {
    name: CONST_COMPONENT.CAROUSEL_ITEM,
    component: 'CarouselSingleComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },    

  audio: {
    name: CONST_COMPONENT.AUDIO,
    component: 'AudioComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  video: {
    name: CONST_COMPONENT.VIDEO,
    component: 'VideoComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  file: {
    name: CONST_COMPONENT.FILE,
    component: 'FileComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  facebookMedia: {
    name: CONST_COMPONENT.FACEBOOK_MEDIA,
    component: 'FacebookMediaComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },

  ecommerce: {
    name: CONST_COMPONENT.ECOMMERCE,
    component: 'EcommerceComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },    

  userInputFlow: {
    name: CONST_COMPONENT.USER_INPUT_FLOW,
    component: 'UserInputFlowComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },    

  userInputFlowSingle: {
    name: CONST_COMPONENT.USER_INPUT_FLOW_SINGLE,
    component: 'UserInputFlowSingleComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },    

  otn: {
    name: CONST_COMPONENT.OTN,
    component: 'OtnComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },   

  recurringNotification: {
    name: CONST_COMPONENT.RECURRING_NOTIFICATION,
    component: 'RcnComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },  

  rcnSingle: {
    name: CONST_COMPONENT.RCN_SINGLE,
    component: 'RcnSingleComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },

  otnSingle: {
    name: CONST_COMPONENT.OTN_SINGLE,
    component: 'OtnSingleComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
      componentHandler: 'componentHandler.js',
    },      
  },    

  button: {
    name: CONST_COMPONENT.BUTTON,
    component: 'ButtonComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  quickReply: {
    name: CONST_COMPONENT.QUICK_REPLY,
    component: 'QuickReplyComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },      
  },      


  trigger: {
    name: CONST_COMPONENT.TRIGGER,
    component: 'TriggerComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  newPostback: {
    name: CONST_COMPONENT.POSTBACK_NEW,
    component: 'NewPostbackComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  sequence: {
    name: CONST_COMPONENT.SEQUENCE,
    component: 'SequenceComponent.js',
    handlers: {
      componentHandler: 'componentHandler.js',
      dataHandler: 'dataHandler.js',
    },
  },

  sequenceSingle: {
    name: CONST_COMPONENT.SEQUENCE_SINGLE,
    component: 'SequenceSingleComponent.js',
    handlers: {
      componentHandler: 'componentHandler.js',
      dataHandler: 'dataHandler.js',
    },
  },

  actionButton: {
    name: CONST_COMPONENT.ACTION_BUTTON,
    component: 'ActionButtonComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  condition: {
    name: CONST_COMPONENT.CONDITION,
    component: 'ConditionComponent.js',
    handlers: {
      dataHandler: 'dataHandler.js',
    },
  },

  componentList: {
    name: CONST_COMPONENT.COMPONENT_LIST,
    component: 'ComponentListComponent.js',
    handlers: {},
  },
}